/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicemissing2Inputs */

const en_ticketsinvoicemissing2 = /** @type {(inputs: Ticketsinvoicemissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice details are missing: company, address and VAT. Without them buyers get no invoice. You find them in the ticket settings.`)
};

const de_ticketsinvoicemissing2 = /** @type {(inputs: Ticketsinvoicemissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es fehlen noch Angaben für die Rechnungen: Firma, Adresse und Umsatzsteuer. Ohne sie bekommen Käufer keine Rechnung. Du findest sie in den Ticket-Einstellungen.`)
};

/**
* | output |
* | --- |
* | "Invoice details are missing: company, address and VAT. Without them buyers get no invoice. You find them in the ticket settings." |
*
* @param {Ticketsinvoicemissing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicemissing2 = /** @type {((inputs?: Ticketsinvoicemissing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicemissing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicemissing2(inputs)
	return de_ticketsinvoicemissing2(inputs)
});
export { ticketsinvoicemissing2 as "ticketsInvoiceMissing" }